module.exports = __webpack_public_path__ + "media/images/vector-6@2x-9775c96524f4b51f4e2ae7596b3b2bd1.png";